// Panel-system.md Phase 3A: the desktop map's "New post" opens the
// observation composer in a right-docked panel (draggable map pin instead
// of the location drill-in) rather than routing to /post/create. Off means the
// app behaves exactly as it did before this phase, except that the
// checklist/before-post/location pickers are always drill-ins now (that part
// ships regardless of this flag — see docs/plans/panel-system.md Phase 3).
// Flip once the dock, the pin layer and the picker drill-ins are verified
// end to end on the desktop shell.
export const DESKTOP_COMPOSER_DOCK_ENABLED = false;
